import React from "react";
import { MemberWithCertificateInfoListItem } from "src/shared/models";
import { StatusLabel, TableProperty } from "src/shared/components";
import { getUSFormattedDate } from "src/shared/utils";

export const memberTableProperties: TableProperty<MemberWithCertificateInfoListItem>[] = [
  {
    title: "Team Member",
    key: "first_name",
    get: (item) => `${item.first_name} ${item.last_name}`,
    sort: ["member_name"],
  },
  {
    title: "Name",
    key: "certificate_name",
    get: (item) => item.certificate_name,
    sort: ["name"],
  },
  {
    title: "Assigned by",
    key: "assigned_by",
    get: (item) => item.assigned_by,
  },
  {
    title: "Expire Date",
    key: "certificate_expire_date",
    get: (item) => getUSFormattedDate(item.certificate_expire_date),
    sort: ["expire_date"],
  },
  {
    title: "Status",
    key: "status",
    get: (item) => <StatusLabel status={item.status} />,
    sort: ["status"],
  },
];
